import type {Ref} from 'vue';
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {api} from "@/service/APIClient";
import {helper} from "@/service/CommonHelper";

export const useSessionHistoryDownload = (loader: Ref<InstanceType<typeof LoaderWrapper> | null>) => {
  const downloadSessionHistory = async (id: number) => {
    loader.value?.show()
    try {
      const data = await api.export('user_sessions', {userId: id});
      helper.downloadBlob(new Blob([data]), `user_${id}_session_report.xlsx`);
    } finally {
      loader.value?.hide()
    }
  }

  return {downloadSessionHistory}
}
